module.exports = __webpack_public_path__ + "img/project-35.b2be38a4.png";